// extracted by mini-css-extract-plugin
export default {"card-header":"AccountAdmin_card-header__zQSaY","content":"AccountAdmin_content__1a4EA"};